/** Recent timer combinations for quick-start. Stored in localStorage. */

const STORAGE_KEY = 'bsg-recent-timers';
const MAX_RECENT = 5;

export interface RecentTimerItem {
  projectId: number;
  projectName: string;
  taskId: number;
  taskName: string;
  description?: string;
}

export function getRecentTimers(): RecentTimerItem[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.slice(0, MAX_RECENT) : [];
  } catch {
    return [];
  }
}

export function saveRecentTimer(item: RecentTimerItem): void {
  const recent = getRecentTimers();
  const updated = [
    item,
    ...recent.filter(
      (r) => !(r.projectId === item.projectId && r.taskId === item.taskId)
    ),
  ].slice(0, MAX_RECENT);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
}

/** Unique project IDs from recent timers, in order of appearance (for project picker) */
export function getRecentProjectIds(): number[] {
  const recent = getRecentTimers();
  const seen = new Set<number>();
  const ids: number[] = [];
  for (const r of recent) {
    if (!seen.has(r.projectId)) {
      seen.add(r.projectId);
      ids.push(r.projectId);
    }
  }
  return ids;
}
